export const BULK_SEARCH_CONSTANTS = {
  HEADING: "Bulk Search",
  SUB_HEADING:
    "Upload your CSV file to perform bulk searches across multiple queries simultaneously. Download the template from below to ensure your data is formatted correctly for processing. Select your search type and submit to view organized results grouped by category.",
  RADIO_GROUP: {
    HEADING: "Search In:",
    OPTIONS: {
      EPH: {
        LABEL: "EPH",
        VALUE: "eph",
      },
      VENDOR_UNIVERSE: {
        LABEL: "Vendor Universe",
        VALUE: "vendor",
      },
    },
  },
  SUBMIT_BUTTON: "Submit",
};
export const BULK_UPLOAD_CONSTANTS = {
  HEADING: "Bulk Profile, DCR Management & eConsents",
  SUB_HEADING:
    "Upload a CSV file to create or update the Profiles, DCR Management, and eConsent records in bulk. The system will automatically validate and process the uploaded records based on the configured business rules.",
  UPLOAD_HEADING: "Upload File",
  SUBMIT_BUTTON: "Submit",
};
export const TRANSLITERATION_CONSTANTS = {
  HEADING: "Transliteration",
  SUB_HEADING:
    "Upload your CSV file to convert text from one script or writing system to another while preserving pronunciation. Download the template below to ensure your data is properly formatted with the required columns. Once you've filled in your content and uploaded the file, submit it to receive your transliterated results.",
  SUBMIT_BUTTON: "Submit",
};
export const BUTTONS = {
  VIEW_HISTORY: "View History",
};
export const BULKS_OPERATIONS_CONSTANTS = {
  HEADING: "Bulk Operations",
  SUB_HEADING: "Select a bulk operation to perform",
  CARDS: [
    {
      title: "Bulk Search",
      description: "Search for multiple customers at once by uploading a list",
      icon: "SearchIcon",
      to: "/bulk-search",
      hasAccess: "canBulkSearch",
      disabledTooltip:
        "You do not have permission to access this feature. Please contact your administrator.",
    },
    {
      title: "Bulk Upload",
      description: "Upload multiple customer records from a file",
      icon: "UploadIcon",
      to: "/bulk-upload",
      hasAccess: "canBulkUpload",
      disabledTooltip:
        "You do not have permission to access this feature. Please contact your administrator.",
    },
    {
      title: "Transliteration",
      description: "Convert text between different writing systems",
      icon: "TranslateIcon",
      to: "/transliteration",
      hasAccess: "canTransliterate",
      disabledTooltip:
        "You do not have permission to access this feature. Please contact your administrator.",
    },
  ],
  VIEW_UPLOAD_HISTORY_BUTTON: "View Upload History",
};
export const UPLOAD_RULES_CONSTANTS = {
  DEFAULT_RULES_INFO:
    "Click to know the automatically applied validation rules",
  CREATE_RULE_HEADING: "Create a New Rule",
  HEADERS: {
    RULE_NAME: "Rule Name",
    FIELD: "Field",
    CONDITION: "Condition",
    VALUE: "Value",
    REGULAR_EXPRESSION: "Regular Expression",
  },
  BUTTONS: {
    ADD_RULE: "Add Rule",
    UPLOAD_RULES: "Upload Predefined Rules",
  },
};
export const RULES_TABLE_CONSTANTS = {
  HEADERS: {
    RULE_NAME: "Rule Name",
    FIELD: "Field",
    CONDITION: "Condition",
    ACTIONS: "Actions",
  },
  HEADING: "Custom Rules",
  EXPORT_BUTTON: "Export to JSON",
};

export const FIELD_OPTIONS = [
  "Country Code",
  "First Name",
  "Middle Name",
  "Last Name",
  "Secondary Last Name",
  "Name",
  "Classification Code",
  "Primary Specialty",
  "Specialty 2",
  "Specialty 3",
  "Identifier 1 Type",
  "Identifier 1 Id",
  "Identifier 2 Type",
  "Identifier 2 Id",
  "Identifier 3 Type",
  "Identifier 3 Id",
  "Rel Hco Enterprise Id",
  "Rel Hco Name",
  "Rel Hco Rank",
  "Rel Hco Clsfctn Cd",
  "Rel Hco Adrs Line 1",
  "Rel Hco Adrs Line 2",
  "Rel Hco Adrs City",
  "Rel Hco Adrs State Code",
  "Rel Hco Adrs Country",
  "Rel Hco Adrs Zip",
  "Hcp Adrs Line 1",
  "Hcp Adrs Line 2",
  "Hcp Adrs City",
  "Hcp Adrs State Code",
  "Hcp Adrs Country",
  "Hcp Adrs Zip",
  "Hcp Adrs Rank",
  "Phone",
  "Email",
  "Address Id",
  "Rel Enterprise Id",
  "Rank",
  "Adrs Line 1",
  "Adrs Line 2",
  "Adrs City",
  "Adrs State Code",
  "Adrs Country",
  "Adrs Zip",
];

export const CONDITION_OPTIONS = [
  { value: "is not null", label: "is not null" },
  { value: "is a number", label: "is a number" },
  { value: "matches regex", label: "matches regex" },
  { value: "is unique", label: "is unique" },
];

export const EXPIRE_TIME_UPLOAD_HISTORY_VIEW_FILE_RESULT = 60; // days
export const EXPIRE_TIME_UPLOAD_HISTORY_DOWNLOAD = 60; // days
export const CHUNK_SIZE_BULK_SERVICE = 3.8 * 1024 * 1024;
export const MAX_CHUNK_SIZE_BULK_SERVICE = 4 * 1024 * 1024;
export const MAX_RETRIES_BULK_SERVICE = 3;
export const HEADER_TRANSLITRATE_BULK_SERVICE = [
  "HCPEnterpriseId",
  "HCOEnterpriseId",
];
export const HEADER_VENDOR_BULK_SERVICE = ["OneKeyId"];
export const HEADER_BULK_SEARCH_BULK_SERVICE = ["id", "firstname", "lastname"];

export const HCP_BULK_SEARCH_BASIC_BULK_SERVICE = ["HCPEnterpriseId"];
export const HCP_BULK_SEARCH_ADVANCE_BULK_SERVICE = [
  "first_name",
  "last_name",
  "active_flag",
  "primary_specialty",
  "classification_code",
  "address_city",
  "address_country",
  "identifier_type",
  "identifier_id",
  "address_postal_code",
  "country_code",
];
export const HCO_BULK_SEARCH_BASIC_BULK_SERVICE = ["HCOEnterpriseId"];
export const HCO_BULK_SEARCH_ADVANCE_BULK_SERVICE = [
  "name",
  "active_flag",
  "primary_specialty",
  "classification_code",
  "address_city",
  "address_country",
  "identifier_type",
  "identifier_id",
  "address_postal_code",
  "country_code",
];

export const HEADER_BULK_UPLOAD_BULK_SERVICE = [
  "entity_type",
  "enterprise_id",
  "country_code",
  "first_name",
  "middle_name",
  "last_name",
  "secondary_last_name",
  "prefix",
  "name",
  "classification_code",
  "active_flag",
  "primary_specialty",
  "specialty_2",
  "specialty_3",
  "phone",
  "email",
  "source_address_id",
  "hco_adrs_line_1",
  "hco_adrs_city",
  "hco_adrs_state_code",
  "hco_adrs_country",
  "hco_adrs_rank",
  "hco_adrs_zip",
  "identifier_1_type",
  "identifier_1_id",
  "identifier_2_type",
  "identifier_2_id",
  "identifier_3_type",
  "identifier_3_id",
  "rel_hco_enterprise_id",
  "rel_hco_rltn_type_code",
  "rel_hco_is_primary",
  "rel_hco_is_parent",
  "rel_hco_name",
  "rel_hco_clsfctn_cd",
  "rel_hco_country_code",
  "rel_hco_adrs_line_1",
  "rel_hco_adrs_line_2",
  "rel_hco_adrs_city",
  "rel_hco_adrs_state_code",
  "rel_hco_adrs_country",
  "rel_hco_adrs_zip",
  "hcp_adrs_source_adrs_id",
  "hcp_adrs_line_1",
  "hcp_adrs_line_2",
  "hcp_adrs_city",
  "hcp_adrs_state_code",
  "hcp_adrs_country",
  "hcp_adrs_zip",
  "hcp_adrs_rank",
  "comments",
  "phone_consent",
  "email_consent",
  "language_code",
  "consent_acquisition_date",
];

export const BULK_UPLOAD_DEFAULT_RULES = [
  {
    category: "Mandatory for All Records",
    rules: [
      "Every record must include Entity Type, Country Code, and Comments.",
    ],
  },
  {
    category: "Creation — HCP (Outside US)",
    rules: [
      "First Name, Last Name, Classification Code, and Primary Specialty are required.",
      "Relationship to an HCO is mandatory. If the HCO already exists, provide HCO Enterprise ID, Relationship Type Code, Is Primary, and Is Parent.",
      "If creating a new HCO, provide Relationship Type Code, Is Primary, Is Parent, HCO Name, Classification Code, Country Code, Address Line 1, City, State Code, Country, and ZIP.",
      "Identifier Type and Identifier ID must be provided together if either is specified.",
    ],
  },
  {
    category: "Creation — HCO (Outside US)",
    rules: [
      "Name, Classification Code, and Primary Specialty are required.",
      "Address fields are required: Address Line 1, City, State Code, Country, Address Rank, and ZIP.",
      "Optionally, if linking to an existing HCO, provide HCO Enterprise ID, Relationship Type Code, Is Primary, and Is Parent.",
      "Optionally, if creating a new related HCO, provide Relationship Type Code, Is Primary, Is Parent, HCO Name, Classification Code, Country Code, Address Line 1, City, State Code, Country, and ZIP.",
      "Identifier Type and Identifier ID must be provided together if either is specified.",
    ],
  },
  {
    category: "Creation — HCP (US)",
    rules: [
      "First Name, Last Name, Classification Code, and Primary Specialty are required.",
      "Address fields are required: Address Line 1, City, State Code, Country, Address Rank, and ZIP.",
      "Identifier Type and Identifier ID must be provided together if either is specified.",
    ],
  },
  {
    category: "Creation — HCO (US)",
    rules: [
      "Name, Classification Code, and Primary Specialty are required.",
      "Address fields are required: Address Line 1, City, State Code, Country, Address Rank, and ZIP.",
      "Identifier Type and Identifier ID must be provided together if either is specified.",
    ],
  },
  {
    category: "Edit — HCP (Outside US)",
    rules: [
      "Enterprise ID, First Name, Last Name, Classification Code, and Active Flag are required.",
      "Optionally, if linking to an existing HCO, provide HCO Enterprise ID, Relationship Type Code, Is Primary, and Is Parent.",
      "Optionally, if creating a new related HCO, provide Relationship Type Code, Is Primary, Is Parent, HCO Name, Classification Code, Country Code, Address Line 1, City, State Code, Country, and ZIP.",
      "Identifier Type and Identifier ID must be provided together if either is specified.",
    ],
  },
  {
    category: "Edit — HCO (Outside US)",
    rules: [
      "Enterprise ID, Name, Classification Code, and Active Flag are required.",
      "To edit an address, provide Source Address ID, Address Line 1, City, State Code, Country, and Address Rank.",
      "Optionally, if linking to an existing HCO, provide HCO Enterprise ID, Relationship Type Code, Is Primary, and Is Parent.",
      "Optionally, if creating a new related HCO, provide Relationship Type Code, Is Primary, Is Parent, HCO Name, Classification Code, Country Code, Address Line 1, City, State Code, Country, and ZIP.",
      "Identifier Type and Identifier ID must be provided together if either is specified.",
    ],
  },
  {
    category: "Edit — HCP (US)",
    rules: [
      "Enterprise ID, First Name, Last Name, Classification Code, and Active Flag are required.",
      "To edit an address, provide Source Address ID, Address Line 1, City, State Code, Country, Address Rank, and ZIP.",
      "Identifier Type and Identifier ID must be provided together if either is specified.",
    ],
  },
  {
    category: "Edit — HCO (US)",
    rules: [
      "Enterprise ID, Name, Classification Code, and Active Flag are required.",
      "To edit an address, provide Source Address ID, Address Line 1, City, State Code, Country, and Address Rank.",
      "Identifier Type and Identifier ID must be provided together if either is specified.",
    ],
  },
];

export const BULK_SEARCH_RECORD_LIMIT_UPLOAD_BASIC_BULK_SERVICE = 50000;
export const BULK_SEARCH_RECORD_LIMIT_UPLOAD_ADVANCE_BULK_SERVICE = 1000;
export const BULK_UPLOAD_RECORD_LIMIT_UPLOAD_BULK_SERVICE = 1000;
export const TRANSLITRATION_RECORD_LIMIT_UPLOAD_BULK_SERVICE = 2000;
export const RECORDS_PER_CHUNK_BULK_SEARCH_ADVANCE_BULK_SERVICE = 100;
export const BULK_SEARCH_RECORD_LIMIT_UPLOAD_BASIC_BULK_SERVICE_VENDOR = 10000;
export const BULK_UPLOAD_RESULT_POLLING_INTERVAL = 30000;
export const BULK_UPLOAD_RESULT_TOTAL_TIME = 120000; // 2 mins
export const BULK_UPLOAD_RESULT_AUTO_REFRESH_INTERVAL = 2; // 2 hrs